import { useNavigate, useParams } from "react-router-dom";
import "./employeePageButtons.css";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BaseSignButton from "@/components/common/baseSignButton";
import { checkPermissionsWithoutAlert } from "@/util";
import { PermissionName } from "@/models/apiModels";

const EmployeePageButtons = () => {
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();
    return (
        <div className="employee-page-button-content">
            {checkPermissionsWithoutAlert(PermissionName.EmployeeGeneralInfo) ? (
                <BaseSignButton
                    className={
                        location.pathname.endsWith("info") ? "employee-page-button-active" : "employee-page-button"
                    }
                    onClick={() => navigate("/employees/" + id + "/info")}
                    style={{ width: 159, display: "flex", justifyContent: "center" }}
                >
                    <i style={{ paddingBottom: "1px" }} className="icon-f icon-GeneralInfoBtnIcon fs-16" />
                    {t("display.GeneralInfo")}
                </BaseSignButton>
            ) : (
                ""
            )}
            {checkPermissionsWithoutAlert(PermissionName.EmployeeDigitalWallet) ? (
                <BaseSignButton
                    className={
                        location.pathname.endsWith("wallet") ? "employee-page-button-active" : "employee-page-button"
                    }
                    style={{ width: 164, display: "flex", justifyContent: "center" }}
                    onClick={() => navigate("/employees/" + id + "/wallet")}
                >
                    <i style={{ paddingBottom: "1px" }} className="icon-f icon-DigitalWalletBtnIcon fs-16" />
                    {t("breadcrumbs.DigitalWallet")}
                </BaseSignButton>
            ) : (
                ""
            )}
            {checkPermissionsWithoutAlert(PermissionName.EmployeeOrders) ? (
                <BaseSignButton
                    className={
                        location.pathname.endsWith("employeeOrders")
                            ? "employee-page-button-active"
                            : "employee-page-button"
                    }
                    style={{ width: 113, display: "flex", justifyContent: "center" }}
                    onClick={() => navigate("/employees/" + id + "/employeeOrders")}
                >
                    <i style={{ paddingBottom: "2px" }} className="icon-f icon-OrdersBtnIcon fs-16" />
                    {t("sidebar.Orders")}
                </BaseSignButton>
            ) : (
                ""
            )}
            {checkPermissionsWithoutAlert(PermissionName.EmployeeAttachedDocs) ? (
                <BaseSignButton
                    className={
                        location.pathname.endsWith("docs") ? "employee-page-button-active" : "employee-page-button"
                    }
                    style={{ width: 174, display: "flex", justifyContent: "center" }}
                    onClick={() => navigate("/employees/" + id + "/docs")}
                >
                    <i style={{ paddingBottom: "1px" }} className="icon-f icon-AttachedDocsBtnIcon fs-16" />
                    {t("display.AttachedDocs")}
                </BaseSignButton>
            ) : (
                ""
            )}
        </div>
    );
};

export default EmployeePageButtons;
